<template>
  <t-form labelWidth="90px">
    <!-- v-if="cptDataForm.dataSource == '4'" -->
    <CptData :data="attribute.cptTableData" :cptDataForm="cptDataForm" />
    <!-- <t-select v-model="attribute.dataSet" size="small">
        <t-option v-for="(item, index) in dataSetData" :key="index" :label="item.COLUMN_NAME"
          :value="item.COLUMN_NAME"/>
      </t-select> -->
    <CptDefault :attribute="attribute" :currentCpt="currentCpt" :cacheComponents="cacheComponents" />
    <t-form-item label="字体">
      <t-select v-model="attribute.textFamily" size="small">
        <t-option v-for="item in textFamilyList" :key="item.value" :label="item.label" :value="item.value" />
      </t-select>
    </t-form-item>
    <t-form-item label="颜色">
      <t-color-picker :colorModes="['monochrome']" format="RGBA" v-model="attribute.textColor" enableAlpha
        size="small" />
    </t-form-item>
    <t-form-item label="渐变">
      <t-radio-group v-model="attribute.enableGradual" size="small">
        <t-radio-button :value="1">关闭</t-radio-button>
        <t-radio-button :value="2">从左到右</t-radio-button>
        <t-radio-button :value="3">从上到下</t-radio-button>
      </t-radio-group>
    </t-form-item>
    <t-form-item label="渐变颜色" v-show="attribute.enableGradual !== 1">
      <e-color-group v-model="attribute.gradualColor" :min="2" :absolute="true" />
    </t-form-item>
    <t-form-item label="背景色" v-show="attribute.enableGradual === 1">
      <t-color-picker :colorModes="['monochrome']" format="RGBA" v-model="attribute.bgColor" enableAlpha size="small" />
    </t-form-item>
    <t-form-item label="sql赋值高亮">
      <div style="display: flex;flex-direction: column;">
        <t-radio-group style="margin-bottom:10px;" v-model="attribute.sqlSetValue" size="small">
          <t-radio-button :value="1">是</t-radio-button>
          <t-radio-button :value="0">否</t-radio-button>
        </t-radio-group>
        <t-color-picker v-if="attribute.sqlSetValue == 1" :colorModes="['monochrome']" format="RGBA"
          v-model="attribute.sqlSetValueColor" enableAlpha size="small" />

      </div>
    </t-form-item>
    <e-collapse title="边框" :expand="false">
      <t-form-item label="边框">
        <t-select v-model="attribute.borderStyle" size="small">
          <t-option label="不显示" value="none" />
          <t-option label="点线" value="dotted" />
          <t-option label="虚线" value="dashed" />
          <t-option label="实线" value="solid" />
          <t-option label="双边框" value="double" />
          <t-option label="凹槽" value="groove" />
          <t-option label="垄状" value="ridge" />
          <t-option label="嵌入" value="inset" />
          <t-option label="外凸" value="outset" />
        </t-select>
      </t-form-item>
      <t-form-item label="粗细">
        <t-input-number :min="1" :max="100" v-model="attribute.borderWidth" size="small" :decimal-places="0" />
      </t-form-item>
      <t-form-item label="颜色">
        <t-color-picker :colorModes="['monochrome']" format="HEX" v-model="attribute.borderColor" size="small" />
      </t-form-item>
      <t-form-item label="圆角">
        <t-input-number :min="0" :max="100" v-model="attribute.borderRadius" size="small" :decimal-places="0" />
      </t-form-item>
    </e-collapse>
    <t-form-item label="加粗">
      <t-radio-group v-model="attribute.fontWeight" size="small">
        <t-radio-button value="lighter">更细</t-radio-button>
        <t-radio-button value="normal">正常</t-radio-button>
        <t-radio-button value="bold">加粗</t-radio-button>
      </t-radio-group>
    </t-form-item>
    <t-form-item label="倾斜">
      <t-radio-group v-model="attribute.fontStyle" size="small">
        <t-radio-button value="normal">正常</t-radio-button>
        <t-radio-button value="italic">倾斜</t-radio-button>
      </t-radio-group>
    </t-form-item>

    <t-form-item label="文字大小">
      <t-input-number :min="12" :max="200" v-model="attribute.textSize" size="small" :decimal-places="0" />
    </t-form-item>
    <t-form-item label="行高">
      <t-input-number :min="10" :max="250" v-model="attribute.textLineHeight" size="small" :decimal-places="0" />
    </t-form-item>
    <t-form-item label="字间距">
      <t-input-number :min="-10" :max="250" v-model="attribute.letterSpacing" size="small" :decimal-places="0" />
    </t-form-item>
    <t-form-item label="对齐方式">
      <t-radio-group v-model="attribute.textAlign" size="small">
        <t-radio-button value="left">靠左</t-radio-button>
        <t-radio-button value="center">居中</t-radio-button>
        <t-radio-button value="right">靠右</t-radio-button>
      </t-radio-group>
    </t-form-item>
    <t-form-item label="下划线">
      <t-select v-model="attribute.textDecoration" size="small">
        <t-option v-for="(item, index) in textDecorationList" :key="index + item.label" :label="item.label"
          :value="item.value" />
      </t-select>
    </t-form-item>
    <t-form-item label="文字超出隐藏">
      <t-radio-group v-model="attribute.isEllipsis" size="small">
        <t-radio-button :value="1">是</t-radio-button>
        <t-radio-button :value="0">否</t-radio-button>
      </t-radio-group>
    </t-form-item>
    <t-form-item label="文字放大动效">
      <t-radio-group v-model="attribute.isScale" size="small">
        <t-radio-button :value="1">是</t-radio-button>
        <t-radio-button :value="0">否</t-radio-button>
      </t-radio-group>
    </t-form-item>
    <t-form-item label="文本行数" v-if="attribute.isEllipsis">
      <t-input-number :min="1" v-model="attribute.lineClamp" size="small" :decimal-places="0" />
    </t-form-item>
    <e-collapse title="条件配色" :expand="true">
      <div style="width: 100%;text-align: center;margin-bottom: 10px"><!--告警配置、环形图/进度图-->
        <t-row>
          <t-col :span="3"></t-col>
          <t-col :span="3">条件</t-col>
          <t-col :span="6">目标值</t-col>
        </t-row>
        <t-row style="margin-top: 14px;">
          <t-col :span="3">值</t-col>
          <t-col :span="3">
            <t-select v-model="attribute.alarmConfig.operator" size="small" style="width: 60px;">
              <t-option value=">" label=">" />
              <t-option value="<" label="<" />
              <t-option value="=" label="=" />
              <t-option value=">=" label=">=" />
              <t-option value="<=" label="<=" />
            </t-select>
          </t-col>
          <t-col :span="6">
            <t-input v-model="attribute.alarmConfig.threshold" size="small" style="width: 100%;" />
          </t-col>
        </t-row>
      </div>
      <div style="display: flex;padding-left: 10px;">
        字体：<t-color-picker :colorModes="['monochrome']" format="HEX" size="small"
          v-model="attribute.alarmConfig.textColor" />
      </div>
      <div style="display: flex;padding-left: 10px;margin-top: 10px">
        背景：<t-color-picker :colorModes="['monochrome']" format="RGBA" size="small"
          v-model="attribute.alarmConfig.bgColor" enableAlpha />
      </div>
    </e-collapse>
  </t-form>
</template>

<script>
import EColorGroup from "@/components/designer/e-color-group.vue";
import CptDefault from '@/components/element/options/comp/cpt-default'
import CptData from '@/components/element/options/comp/cpt-data'
import { executeSelectFun } from "@/utils/refresh-cpt-data";
export default {
  name: "cpt-text-option",
  components: { EColorGroup, CptDefault, CptData },
  props: {
    attribute: Object,
    cptDataForm: Object,
    currentCpt: Object,
    cptFuncOpened: Object,
    cacheComponents: Array,
    refMap: Object,
  },
  data() {
    return {
      textDecorationList: [{ label: '无', value: 'none' }, { label: '下划线', value: 'underline' }, { label: '上划线', value: 'overline' },
      { label: '穿过文字', value: 'line-through' }],
      textFamilyList: [],
      // dataSetData:[],
      // cptTableData:[{"name":"value","value":""}]
    }
  },
  mounted() {
    // console.log(this.cptDataForm,'attribute')
    console.log(this.refMap, 'refMap')
  },
  created() {
    this.textFamilyList = require('@/assets/font/font-list')
    // if(this.cptDataForm.dataSource == '4') {
    //   // this.dataSql(this.cptDataForm);
    // }
  },
  methods: {
    // async dataSql(cptDataForm) {
    //   this.dataSetData = await executeSelectFun(cptDataForm);
    //   console.log(this.dataSetData,'返回数据集key')
    // }
  }
}
</script>

<style scoped></style>
